import React, { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  addProduct,
  fetchProductsOptions,
  selectProductsOptions,
  setOptions,
  addMultisplit,
} from "../productsAdminSlice";
import { createProduct } from "./utils";
import AdminForm from "../../AdminForm";
import { fetchAllTags, selectAllTags } from "features/admin/Tags/tagsAdminSlice";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

const AddProduct = () => {
  const dispatch: any = useDispatch();
  const [progress, setProgress] = useState(0);
  const fields = useSelector(selectProductsOptions);
  const navigate = useNavigate();
  const allTags = useSelector(selectAllTags);
  const location: any = useLocation();
  const { type } = location.state!;
  useEffect(() => {
    batch(() => {
      dispatch(fetchProductsOptions(type));
      dispatch(fetchAllTags());
    });

    return () => {
      dispatch(setOptions([]));
    };
  }, [dispatch]);

  const onSubmit = async (data: any) => {
    const product = createProduct(data, allTags, type);
    let wasCreated = false;

    if (type === "product") {
      wasCreated = await dispatch(
        addProduct(product, (event) => {
          if (event.total) {
            setProgress(Math.round((100 * event.loaded) / event.total));
          }
        })
      );
    } else {
      wasCreated = await dispatch(
        addMultisplit(product, (event) => {
          if (event.total) {
            setProgress(Math.round((100 * event.loaded) / event.total));
          }
        })
      );
    }

    if (wasCreated) {
      navigate("/products", { state: { type } });
    } else {
      setProgress(0);
    }
  };

  return (
    <>
      {fields.length !== 0 && (
        <>
          <p>
            Мета заглавие (дължина): 20 - 60 знака
            <br />
            Мета тагове (брой): 4 - 9 тага
            <br />
            Мета описание (дължина): 50 - 160 знака
          </p>
          <AdminForm
            formTitle={`Добавяне на ${type === "product" ? "климатик" : "мултисплит система"}`}
            onSubmit={onSubmit}
            product={fields}
            progress={progress}
          />
        </>
      )}
    </>
  );
};

export default AddProduct;
